"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnitedStatesStateOrTerritoryKeyFromString = exports.UnitedStatesStatesRecord = exports.UnitedStatesStateTerritoryKey = void 0;
var UnitedStatesStateTerritoryKey;
(function (UnitedStatesStateTerritoryKey) {
    // Catch alls
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Other"] = 0] = "Other";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Unknown"] = 1] = "Unknown";
    // Non-main 50
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["DistrictOfColumbia"] = 2] = "DistrictOfColumbia";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["PuertoRico"] = 3] = "PuertoRico";
    // Main 50 states
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Alaska"] = 4] = "Alaska";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Alabama"] = 5] = "Alabama";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Arkansas"] = 6] = "Arkansas";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Arizona"] = 7] = "Arizona";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["California"] = 8] = "California";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Colorado"] = 9] = "Colorado";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Connecticut"] = 10] = "Connecticut";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Delaware"] = 11] = "Delaware";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Florida"] = 12] = "Florida";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Georgia"] = 13] = "Georgia";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Hawaii"] = 14] = "Hawaii";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Iowa"] = 15] = "Iowa";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Idaho"] = 16] = "Idaho";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Illinois"] = 17] = "Illinois";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Indiana"] = 18] = "Indiana";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Kansas"] = 19] = "Kansas";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Kentucky"] = 20] = "Kentucky";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Louisiana"] = 21] = "Louisiana";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Massachusetts"] = 22] = "Massachusetts";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Maryland"] = 23] = "Maryland";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Maine"] = 24] = "Maine";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Michigan"] = 25] = "Michigan";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Minnesota"] = 26] = "Minnesota";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Missouri"] = 27] = "Missouri";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Mississippi"] = 28] = "Mississippi";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Montana"] = 29] = "Montana";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["NorthCarolina"] = 30] = "NorthCarolina";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["NorthDakota"] = 31] = "NorthDakota";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Nebraska"] = 32] = "Nebraska";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["NewHampshire"] = 33] = "NewHampshire";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["NewJersey"] = 34] = "NewJersey";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["NewMexico"] = 35] = "NewMexico";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Nevada"] = 36] = "Nevada";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["NewYork"] = 37] = "NewYork";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Ohio"] = 38] = "Ohio";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Oklahoma"] = 39] = "Oklahoma";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Oregon"] = 40] = "Oregon";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Pennsylvania"] = 41] = "Pennsylvania";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["RhodeIsland"] = 42] = "RhodeIsland";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["SouthCarolina"] = 43] = "SouthCarolina";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["SouthDakota"] = 44] = "SouthDakota";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Tennessee"] = 45] = "Tennessee";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Texas"] = 46] = "Texas";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Utah"] = 47] = "Utah";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Virginia"] = 48] = "Virginia";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Vermont"] = 49] = "Vermont";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Washington"] = 50] = "Washington";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Wisconsin"] = 51] = "Wisconsin";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["WestVirginia"] = 52] = "WestVirginia";
    UnitedStatesStateTerritoryKey[UnitedStatesStateTerritoryKey["Wyoming"] = 53] = "Wyoming";
})(UnitedStatesStateTerritoryKey = exports.UnitedStatesStateTerritoryKey || (exports.UnitedStatesStateTerritoryKey = {}));
const US = UnitedStatesStateTerritoryKey;
// Map abbreviations to states
exports.UnitedStatesStatesRecord = Object.freeze({
    [US.Other]: { name: 'Other', abbreviation: '' },
    [US.Unknown]: { name: 'Unknown', abbreviation: '' },
    [US.DistrictOfColumbia]: { name: 'District of Columbia', abbreviation: 'DC' },
    [US.PuertoRico]: { name: 'Puerto Rico', abbreviation: 'PR' },
    [US.Alaska]: { name: 'Alaska', abbreviation: 'AK' },
    [US.Alabama]: { name: 'Alabama', abbreviation: 'AL' },
    [US.Arkansas]: { name: 'Arkansas', abbreviation: 'AR' },
    [US.Arizona]: { name: 'Arizona', abbreviation: 'AZ' },
    [US.California]: { name: 'California', abbreviation: 'CA' },
    [US.Colorado]: { name: 'Colorado', abbreviation: 'CO' },
    [US.Connecticut]: { name: 'Connecticut', abbreviation: 'CT' },
    [US.Delaware]: { name: 'Delaware', abbreviation: 'DE' },
    [US.Florida]: { name: 'Florida', abbreviation: 'FL' },
    [US.Georgia]: { name: 'Georgia', abbreviation: 'GA' },
    [US.Hawaii]: { name: 'Hawaii', abbreviation: 'HI' },
    [US.Iowa]: { name: 'Iowa', abbreviation: 'IA' },
    [US.Idaho]: { name: 'Idaho', abbreviation: 'ID' },
    [US.Illinois]: { name: 'Illinois', abbreviation: 'IL' },
    [US.Indiana]: { name: 'Indiana', abbreviation: 'IN' },
    [US.Kansas]: { name: 'Kansas', abbreviation: 'KS' },
    [US.Kentucky]: { name: 'Kentucky', abbreviation: 'KY' },
    [US.Louisiana]: { name: 'Louisiana', abbreviation: 'LA' },
    [US.Massachusetts]: { name: 'Massachusetts', abbreviation: 'MA' },
    [US.Maryland]: { name: 'Maryland', abbreviation: 'MD' },
    [US.Maine]: { name: 'Maine', abbreviation: 'ME' },
    [US.Michigan]: { name: 'Michigan', abbreviation: 'MI' },
    [US.Minnesota]: { name: 'Minnesota', abbreviation: 'MN' },
    [US.Missouri]: { name: 'Missouri', abbreviation: 'MO' },
    [US.Mississippi]: { name: 'Mississippi', abbreviation: 'MS' },
    [US.Montana]: { name: 'Montana', abbreviation: 'MT' },
    [US.NorthCarolina]: { name: 'North Carolina', abbreviation: 'NC' },
    [US.NorthDakota]: { name: 'North Dakota', abbreviation: 'ND' },
    [US.Nebraska]: { name: 'Nebraska', abbreviation: 'NE' },
    [US.NewHampshire]: { name: 'New Hampshire', abbreviation: 'NH' },
    [US.NewJersey]: { name: 'New Jersey', abbreviation: 'NJ' },
    [US.NewMexico]: { name: 'New Mexico', abbreviation: 'NM' },
    [US.Nevada]: { name: 'Nevada', abbreviation: 'NV' },
    [US.NewYork]: { name: 'New York', abbreviation: 'NY' },
    [US.Ohio]: { name: 'Ohio', abbreviation: 'OH' },
    [US.Oklahoma]: { name: 'Oklahoma', abbreviation: 'OK' },
    [US.Oregon]: { name: 'Oregon', abbreviation: 'OR' },
    [US.Pennsylvania]: { name: 'Pennsylvania', abbreviation: 'PA' },
    [US.RhodeIsland]: { name: 'Rhode Island', abbreviation: 'RI' },
    [US.SouthCarolina]: { name: 'South Carolina', abbreviation: 'SC' },
    [US.SouthDakota]: { name: 'South Dakota', abbreviation: 'SD' },
    [US.Tennessee]: { name: 'Tennessee', abbreviation: 'TN' },
    [US.Texas]: { name: 'Texas', abbreviation: 'TX' },
    [US.Utah]: { name: 'Utah', abbreviation: 'UT' },
    [US.Virginia]: { name: 'Virginia', abbreviation: 'VA' },
    [US.Vermont]: { name: 'Vermont', abbreviation: 'VT' },
    [US.Washington]: { name: 'Washington', abbreviation: 'WA' },
    [US.Wisconsin]: { name: 'Wisconsin', abbreviation: 'WI' },
    [US.WestVirginia]: { name: 'West Virginia', abbreviation: 'WV' },
    [US.Wyoming]: { name: 'Wyoming', abbreviation: 'WY' },
});
const USSR = exports.UnitedStatesStatesRecord; // ♫ You don't know how lucky you are ♫
const match = (a, b) => a.toLowerCase() === b.toLowerCase();
function getUnitedStatesStateOrTerritoryKeyFromAbbreviation(abbreviation) {
    const key = Object.keys(USSR).find((key) => {
        var _a;
        return match(((_a = USSR[+key]) === null || _a === void 0 ? void 0 : _a.abbreviation) || '', abbreviation);
    });
    return key ? parseInt(key) : US.Unknown;
}
function getUnitedStatesStateOrTerritoryKeyFromName(name) {
    const key = Object.keys(USSR).find((key) => { var _a; return match(((_a = USSR[+key]) === null || _a === void 0 ? void 0 : _a.name) || '', name); });
    return key ? parseInt(key) : US.Unknown;
}
/**
 * Accepts either the abbreviation or full name of a state or territory and returns the corresponding UnitedStatesStateTerritoryKey
 * @param state
 * @returns
 */
function getUnitedStatesStateOrTerritoryKeyFromString(state) {
    // Try based on abbreviation
    const fromAbbreviation = getUnitedStatesStateOrTerritoryKeyFromAbbreviation(state);
    if (fromAbbreviation != UnitedStatesStateTerritoryKey.Unknown) {
        return fromAbbreviation;
    }
    // Try based on full name
    const fromFullName = getUnitedStatesStateOrTerritoryKeyFromName(state);
    return fromFullName;
}
exports.getUnitedStatesStateOrTerritoryKeyFromString = getUnitedStatesStateOrTerritoryKeyFromString;
//# sourceMappingURL=usStatesAndTerritories.js.map